import { render, staticRenderFns } from "./company-employee.vue?vue&type=template&id=2862541d&scoped=true&"
import script from "./company-employee.vue?vue&type=script&lang=js&"
export * from "./company-employee.vue?vue&type=script&lang=js&"
import style0 from "./company-employee.vue?vue&type=style&index=0&id=2862541d&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2862541d",
  null
  
)

export default component.exports